'use client';

import { get } from 'lodash-es';
import MaterialLink from '@/components/material-link';
import { useAppContext } from '@/contexts/app';

interface City {
  id: string;
  name: string;
  slug: string;
}

export default function CitiesList({ cities }: { cities: City[] }) {
  const { loggedInUser } = useAppContext();

  return (
    <ul>
      {cities.map((city) => (
        <li key={city.id}>
          <MaterialLink href={`/cities/${city.slug}`}>
            {city.name}
          </MaterialLink>
          {city.id === get(loggedInUser, 'primaryCity.id') && ' (Primary City)'}
        </li>
      ))}
    </ul>
  );
}
